const features = {
    'compelling_advertising': 'Generate advertising descriptions guaranteed to sell with little to no thought.',
    'binding_contracts': 'Create a customized, binding contract in just 8 easy steps to fit any need or scenario.',
    'professional_messaging': 'Draft clear, professional messages without worrying about the fine tuning.',
    'helpful_advice': 'Ask about nearly any scenario. Whether a sticky situation or general question.'
}

const benefits = {
    'optimized_workflow': 'Enjoy a beautifully designed, user-friendly interface to quickly get to the point about what you need done.',
    'engineered_communications': 'Benefit from extremely well engineered prompts and messaging to get the best results for your tasks.',
    'ai': 'Put your business ahead of the rest by utilizing state of art, AI technology that streamlines your business and increases your productivity.'

}

module.exports = {features, benefits}